import React, { useEffect, useState } from 'react';
import { Layout, Select, Row, Col, Card, Modal, Button, Popconfirm, Table, Input, notification, Form, DatePicker } from 'antd';
import {
    DeleteOutlined,
    CheckCircleOutlined,
    InfoCircleOutlined,
    CloseCircleOutlined,
    EditOutlined,
    PlusCircleOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import { createupdate, getall, remove, getbyid, create, getdatawhere } from '../api/api';
import { Typography } from 'antd';
import { Link, browserHistory } from 'react-router';
import { isLogin } from '../reducer/LocalStoradge'
import styled from 'styled-components';
import moment from 'moment';
moment.locale('id')


const { Header, Sider, Content } = Layout;
const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const InputBoxAbove = styled.div`
    border: 1px solid #a5b1c2;
    margin-top: 20px;
    padding: 10px;
    border-radius: 5px 5px 0px 0px ;
`;
const InputBoxCenter = styled.div`
    border-left: 1px solid #a5b1c2;
    border-right: 1px solid #a5b1c2;
    border-bottom: 1px solid #a5b1c2;
    padding: 10px;
`;

const InputBoxBottom = styled.div`
    border-bottom: 1px solid #a5b1c2;
    border-left: 1px solid #a5b1c2;
    border-right: 1px solid #a5b1c2;
    padding: 10px;
    border-radius: 0px 0px 5px 5px;
`;

const Judul = styled.input`
    width: 100%;
    border: 0px;
    font-family: 'Montserrat', sans-serif;
    margin-top: 20px;
    &:focus{
        outline: none;
    }
`;

const Label = styled.p`
    margin-bottom: 2px;
    font-weight: bold;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
`;

const Buttonx = styled.button`
    margin-top: 20px;
    background-color:#4b7bec;
    border: 1px solid #4b7bec;
    border-radius: 5px;
    color: white;
    padding: 7px;
    float: right;
    cursor: pointer;
    font-weight: bold;
    width: 100%;
    &:hover{
        color: #3498db;
        border: 1px solid #3498db;
        font-weight: bold;
    }
`;

const Inputx = styled.input`
    width: 100%;
    border: 0px;
    font-family: 'Montserrat', sans-serif;
    &:focus{
        outline: none;
    }
`;

function Pasien() {

    const [modal, setModal] = useState(false)
    const [modalicd, setModalIcd] = useState(false)
    const [modalrm, setModalRm] = useState(false)
    const [id, setId] = useState('')
    const [listPegawai, setListPegawai] = useState([])
    const [nik, setNik] = useState('');
    const [rm, setRm] = useState('');
    const [nama, setNama] = useState('');
    const [bpjs, setBpjs] = useState('');
    const [jenis_kelamin, setJenisKelamin] = useState('')
    const [alamat, setAlamat] = useState('');
    const [tempat_lahir, setTempatlahir] = useState('')//tempatlahir
    const [tanggal_lahir, setTanggallahir] = useState('')//tanggal lahir
    const [no_hp, setNohp] = useState('')//nohp
    const [agama, setAgama] = useState('') //agama
    const [pekerjaan, setPekerjaan] = useState('')//pelerjaan
    const [status, setStatus] = useState('')//status
    const [faskes_id, setFaskesId] = useState('')
    const [nama_kepala_keluarga, setNamakepalakeluarga] = useState('')//namakk

    const [tanggal, setTanggal] = useState(moment().format('YYYY-MM-DD'))
    const [icd, setIcd] = useState('')
    const [keterangan, setKeterangan] = useState('')

    const [agamalist, setAgamalist] = useState([])
    const [icdlist, setIcdlist] = useState([])
    const [pekerjaanlist, setPekerjaanlist] = useState([])
    const [statuskeluargalist, setStatuskeluargalist] = useState([])
    const [pasienList, setPasienList] = useState([])
    const [pasienListForSearch, setPasienListForSearch] = useState([])
    const [rmtodaylist, setRmTodayList] = useState([])
    const [rmall, setRmAll] = useState([])


    useEffect(() => {
        getAttr()
        getPasien()
    }, []);



    const modelTrigger = () => {
        setModal(!modal)
    }

    const modalTriggerIcd = async (rm) => {
        setRm(rm)
        await getRiwayat()
        setModalIcd(!modalicd)
    }

    const modalTriggerRm = async () => {
        // setRm(rm)
        // console.log(rm)
        // await getRiwayatByRm(rm)
        setModalRm(!modalrm)
    }

    const getPasien = async () => {
        const data = []
        const _listpasien = await getall({ table: 'table_pasien' })

        console.log(_listpasien)
        setPasienListForSearch(_listpasien)
        let data_length = _listpasien.length

        for (let i = 0; i < data_length; i++) {
            data.push({
                nomor: i + 1,
                id: _listpasien[i].id,
                rm: _listpasien[i].rm,
                nama: _listpasien[i].nama,
                jenis_kelamin: _listpasien[i].jenis_kelamin,
            })
        }
        setPasienList(data)

    }

    const getPasienByRm = async (rm) => {
        const data = []
        const datas = {
            table: 'table_pasien',
            url: 'getallbyid',
            payload: {
                rm,
            }
        }

        const _listpasien = await getdatawhere(datas)
        let data_length = _listpasien.length

        for (let i = 0; i < data_length; i++) {
            data.push({
                nomor: i + 1,
                id: _listpasien[i].id,
                rm: _listpasien[i].rm,
                nama: _listpasien[i].nama,
                jenis_kelamin: _listpasien[i].jenis_kelamin,
            })
        }
        setPasienList(data)

    }

    const getPasienById = async (id) => {
        const url = 'getpasienbyid'
        setId(id)
        let pasienbyid = await getbyid(id, url)

        setNik(pasienbyid[0].nik);
        setRm(pasienbyid[0].rm);
        setNama(pasienbyid[0].nama);
        setBpjs(pasienbyid[0].bpjs);
        setJenisKelamin(pasienbyid[0].jenis_kelamin)
        setAlamat(pasienbyid[0].alamat);
        setTempatlahir(pasienbyid[0].tempat_lahir)//tempatlahir
        setTanggallahir(pasienbyid[0].tanggal_lahir)//tanggal lahir
        setNohp(pasienbyid[0].no_hp)//nohp
        setAgama(pasienbyid[0].agama) //agama
        setPekerjaan(pasienbyid[0].pekerjaan)//pelerjaan
        setStatus(pasienbyid[0].status)//status
        setNamakepalakeluarga(pasienbyid[0].nama_kepala_keluarga)//namakk

        modelTrigger()
    }

    const getAttr = async () => {

        const _listagama = await getall({ table: 'table_agama' })
        const _listpekerjaan = await getall({ table: 'table_pekerjaan' })
        const _liststatus = await getall({ table: 'table_status' })
        const _listpasien = await getall({ table: 'table_pasien' })
        const _listicd = await getall({ table: 'table_icd' })

        setAgamalist(_listagama)
        setPekerjaanlist(_listpekerjaan)
        setStatuskeluargalist(_liststatus)
        setPasienList(_listpasien)
        setIcdlist(_listicd)

    }


    const removepasien = async (id) => {

        const datas = {
            table: 'table_pasien',
            url: 'remove',
            payload: {
                id,
            }
        }
        const hapus = await remove(datas)
        console.log(hapus)
        if (hapus === 1) {
            notification.open({
                message: 'Data Berhasil dihapus',
                description:
                    '',
                icon: <CheckCircleOutlined style={{ color: '#00b894' }} />,
            });
            getPasien()
        }
    }

    const removerm = async (id, rm) => {

        const datas = {
            table: 'table_rekam_medik_pasien',
            url: 'remove',
            payload: {
                id,
            }
        }
        const hapus = await remove(datas)
        console.log(hapus)
        if (hapus === 1) {
            notification.open({
                message: 'Data Berhasil dihapus',
                description:
                    '',
                icon: <CheckCircleOutlined style={{ color: '#00b894' }} />,
            });
            getRiwayat(rm)
            resetFormIcd()
        }
    }

    const resetFormIcd = () => {
        setIcd('')
        setKeterangan('')
    }

    const update = async () => {
        if (nik === '' || nama === '' || rm === '') {
            notification.open({
                message: 'Gagal Menyimnpan',
                description:
                    'Form tidak boleh kosong',
                icon: <CloseCircleOutlined style={{ color: '#e84118' }} />,
            });
        } else {
            let datas = {
                id,
                nik,
                rm,
                nama,
                bpjs,
                jenis_kelamin,
                alamat,
                tempat_lahir,
                tanggal_lahir,
                no_hp,
                agama,
                pekerjaan,
                status,
                faskes_id,
                nama_kepala_keluarga,
            }
            const apiurl = 'updatepasien';
            console.log(apiurl)
            let createpegawai = await createupdate(datas, apiurl)
            if (createpegawai === 1) {
                notification.open({
                    message: 'Data Berhasil disimpan',
                    description:
                        '',
                    icon: <CheckCircleOutlined style={{ color: '#00b894' }} />,
                });
                getPasien()
                modelTrigger()
                // resetForm()
            } else {
                notification.open({
                    message: 'Gagal Menyimpan Data',
                    description:
                        '',
                    icon: <CloseCircleOutlined style={{ color: '#e84118' }} />,
                });
            }
        }
    }

    const getRiwayat = async (rm) => {
        const data = []
        const datas = {
            table: 'table_rekam_medik_pasien',
            url: 'getrmtoday',
            payload: {
                rm,
                tanggal,
            }
        }

        const getrmtoday = await getdatawhere(datas)
        console.log('a')
        console.log(getrmtoday)

        for (let i = 0; i < getrmtoday.length; i++) {
            data.push({
                no: i + 1,
                id: getrmtoday[i].id,
                icd: getrmtoday[i].icd,
                nama_penyakit: getrmtoday[i].nama_penyakit,
            })
        }
        setRmTodayList(data)
    }

    const getRiwayatByRm = async (rm) => {
        console.log(rm)
        const datas = {
            table: 'table_rekam_medik_pasien',
            url: 'getrm',
            payload: {
                rm,
            }
        }

        const getrmall = await getdatawhere(datas)
        console.log(getrmall)

        setRmAll(getrmall)
        modalTriggerRm()
    }

    const createRiwayat = async () => {
        console.log(rm)

        const datas = {
            table: 'table_rekam_medik_pasien',
            url: 'create',
            payload: {
                rm,
                icd,
                tanggal,
                keterangan,
            }
        }

        const _create = await create(datas)

        if (_create === 1) {
            notification.open({
                message: 'Data Berhasil disimpan',
                description:
                    '',
                icon: <CheckCircleOutlined style={{ color: '#00b894' }} />,
            });
            getRiwayat()
            // modelTrigger()
            // resetForm()
            resetFormIcd()
        } else {
            notification.open({
                message: 'Gagal Menyimpan Data',
                description:
                    '',
                icon: <CloseCircleOutlined style={{ color: '#e84118' }} />,
            });
        }
    }

    const columns = [
        {
            title: 'No',
            key: 'no',
            dataIndex: 'nomor'
        },
        {
            title: 'No RM',
            key: 'rm',
            dataIndex: 'rm'
        },
        {
            title: 'Nama',
            key: 'nama',
            dataIndex: 'nama'
        },
        {
            title: 'Jenis Kelamin',
            key: 'jenis_kelamin',
            dataIndex: 'jenis_kelamin'
        },
        {
            title: 'Tempat, tanggal lahir',
            key: 'action',
            render: (text, record) => (
                <span>
                    {record.tempat_lahir}, {moment(record.tanggal_lahir).format('LL')}
                </span>
            ),
        },
        {
            title: 'Umur',
            key: 'action',
            render: (text, record) => (
                <span>
                    {moment(record.tanggal_lahir, "YYYY-MM-DD").fromNow()}
                </span>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <span>
                    <Button key="edit" onClick={() => getPasienById(record.id)} style={{ marginLeft: 10 }} type="primary" icon={<EditOutlined />} >Edit</Button>
                    <Button key="riwayat" onClick={() => modalTriggerIcd(record.rm)} style={{ marginLeft: 10 }} type="primary" icon={<PlusCircleOutlined />} >Tambah RM</Button>
                    <Button key="riwayatall" onClick={() => getRiwayatByRm(record.rm)} style={{ marginLeft: 10 }} type="primary" icon={<PlusCircleOutlined />} >Lihat RM</Button>
                    <Popconfirm
                        title="Anda yakin menghapus Data ini?"
                        onConfirm={() => removepasien(record.id)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button key="hapus" style={{ marginLeft: 10 }} type="danger" icon={<DeleteOutlined />} >Hapus</Button>
                    </Popconfirm>
                </span>
            ),
        },
    ];

    const columnsriwayat = [
        {
            title: 'Kode ICD',
            key: 'icd',
            dataIndex: 'icd'
        },
        {
            title: 'Nama Penyakit',
            key: 'nama_penyakit',
            dataIndex: 'nama_penyakit'
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <span>
                    <Popconfirm
                        title="Anda yakin menghapus Data ini?"
                        onConfirm={() => removerm(record.id, record.rm)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button key="hapus" style={{ marginLeft: 10 }} type="danger" icon={<DeleteOutlined />} >Hapus</Button>
                    </Popconfirm>
                </span>
            ),
        },
    ];



    const onChangeTanggalLahir = (value, string) => {
        console.log(string)
        setTanggallahir(string)
    }

    const onChangeAgama = value => {
        setAgama(value)
    }

    const onChangePekerjaan = value => {
        setPekerjaan(value)
    }

    const onChangeStatus = value => {
        setStatus(value)
    }

    const onChangeJenisKelamin = value => {
        setJenisKelamin(value)
    }

    const onChangeIcd = value => {
        setIcd(value)
    }

    const onChangePasien = value => {
        getPasienByRm(value)
    }

    //   const onChangePoli = value => {
    //     setPoli(value)
    //     setKodeAntrian(value)
    //   }

    const dateFormat = 'YYYY-MM-DD';


    return (
        <Content
            className="site-layout-background"
            style={{
                margin: '24px 16px',
                padding: 24,
                minHeight: '100%',
            }}
        >

            <Card
                title="Pasien"
                //extra={<Button type="dashed" onClick={() => browserHistory.push('/addpegawai')}>Tambah Pegawai </Button>}
                style={{ width: '100%' }}
                headStyle={{ color: 'white', backgroundColor: '#0984e3', fontWeight: 'bold', fontSize: 20 }}
            >
                <Select
                    showSearch
                    style={{ width: '100%', marginBottom: 10 }}
                    placeholder="Cari Pasien"
                    optionFilterProp="children"
                    onChange={onChangePasien}
                // value={jenis_kelamin}
                >
                    <Option value="">Cari Pasien</Option>
                    {pasienListForSearch.map((data, index) =>
                        <Option value={data.rm}>{data.rm} - {data.bpjs} - {data.nama}</Option>
                    )}
                </Select>
                <Button block onClick={getPasien} style={{ marginTop: 20 }}> Tampilkan Semua</Button>
            </Card>

            <Table columns={columns} dataSource={pasienList} style={{ marginTop: 20 }} />

            <Modal
                title="Edit Data Pasien"
                centered
                visible={modal}
                onOk={update}
                onCancel={modelTrigger}
                width={1000}
            >
                <Row>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Nomor Induk Kependudukan (NIK)</Label>
                        <Input placeholder="Nama Induk Kependudukan (NIK)" value={nik} style={{ width: '100%' }} onChange={({ target }) => setNik(target.value)} />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Nomor Rekam Medis</Label>
                        <Input value={rm} style={{ width: '100%' }} onChange={({ target }) => setRm(target.value)} placeholder="Nomor Rekam Medis Lama / Lokal" />

                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Nama Pasien</Label>
                        <Input value={nama} style={{ width: '100%' }} onChange={({ target }) => setNama(target.value)} placeholder="Nama Lengkap" />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Jenis Kelamin</Label>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="Jenis Kelamin"
                            optionFilterProp="children"
                            onChange={onChangeJenisKelamin}
                            value={jenis_kelamin}
                        >
                            <Option value="Laki Laki">Laki Laki</Option>
                            <Option value="Perempuan">Perempuan</Option>
                        </Select>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Nomor BPJS</Label>
                        <Input value={bpjs} style={{ width: '100%' }} onChange={({ target }) => setBpjs(target.value)} placeholder="Nama Lengkap" />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Nomor HP / Telp</Label>
                        <Input value={no_hp} style={{ width: '100%' }} onChange={({ target }) => setNohp(target.value)} placeholder="Nomor Telp / Hp" />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Tempat Lahir</Label>
                        <Input value={tempat_lahir} style={{ width: '100%' }} onChange={({ target }) => setTempatlahir(target.value)} placeholder="Tempat Lahir" />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Tanggal Lahir</Label>
                        <DatePicker
                            style={{ width: '100%' }}
                            onChange={onChangeTanggalLahir}
                            defaultValue={moment(tanggal_lahir, dateFormat)} format={dateFormat}
                        />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Agama</Label>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="Agama"
                            optionFilterProp="children"
                            onChange={onChangeAgama}
                            value={agama}
                        >
                            {
                                agamalist.map((item, index) =>
                                    <Option value={item.agama}>{item.agama}</Option>
                                )
                            }
                        </Select>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Pekerjaan</Label>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="Pekerjaan"
                            optionFilterProp="children"
                            onChange={onChangePekerjaan}
                            value={pekerjaan}
                        >
                            {
                                pekerjaanlist.map((item, index) =>
                                    <Option value={item.pekerjaan}>{item.pekerjaan}</Option>
                                )
                            }
                        </Select>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Nama Kepala Keluarga</Label>
                        <Input value={nama_kepala_keluarga} style={{ width: '100%' }} onChange={({ target }) => setNamakepalakeluarga(target.value)} placeholder="Nama Kepala Keluarga" />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 15 }}>
                        <Label>Status Keluarga</Label>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="Status Dalam Keluarga"
                            optionFilterProp="children"
                            onChange={onChangeStatus}
                            value={status}
                        >
                            {
                                statuskeluargalist.map((item, index) =>
                                    <Option value={item.status}>{item.status}</Option>
                                )
                            }
                        </Select>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ paddingLeft: 5, paddingRight: 5 }}>
                        <Label>Alamat</Label>
                        <Input value={alamat} style={{ width: '100%' }} onChange={({ target }) => setAlamat(target.value)} placeholder="Nama Kepala Keluarga" />
                    </Col>
                </Row>
            </Modal>

            <Modal
                title="Tambah Rekam Medik"
                centered
                visible={modalicd}
                //onOk={update}
                onCancel={modalTriggerIcd}
                width={1000}
                footer={null}
            >
                <Form name="horizontal_login" layout="inline" onFinish={() => createRiwayat()} style={{ backgroundColor: '#0984e3', padding: 20, marginBottom: 20 }}>
                    <Row style={{ width: '100%', marginBottom: 5, backgroundColor: '#0984e3' }} >
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                            <Form.Item
                                rules={[{ required: true, message: 'kosong' }]}
                                style={{ width: '100%' }}
                            >
                                <Label style={{ color: 'white' }}>Kode ICD</Label>
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder="Select ICD Code"
                                    optionFilterProp="children"
                                    style={{ width: '100%', borderWidth: 0 }}
                                    onChange={onChangeIcd}
                                //value={pengikut}
                                >
                                    <Option value="">Diagnosa Pasien</Option>
                                    {icdlist.map((data, index) =>
                                        <Option value={data.icd}>{data.icd} - {data.nama_penyakit}</Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ marginTop: 20 }}>
                            <Form.Item
                                rules={[{ required: true, message: 'kosong' }]}
                                style={{ width: '100%' }}
                            >
                                <Label style={{ color: 'white' }}>Keterangan Lainnya</Label>
                                <TextArea rows={4} onChange={({ target }) => setKeterangan(target.value)} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                            <Button block onClick={createRiwayat} style={{ marginTop: 20 }}> Simpan</Button>
                        </Col>
                    </Row>
                </Form>
                <Table columns={columnsriwayat} dataSource={rmtodaylist} />

            </Modal>

            <Modal
                title="Rekam Medik"
                centered
                visible={modalrm}
                //onOk={update}
                onCancel={modalTriggerRm}
                width={1000}
                footer={null}
            >
                <table style={{ fontSize: 12, width: '100%' }}>
                    <table style={{ width: '100%', marginBottom: 10 }}>
                        <tbody>
                            <tr>
                                <td style={{ fontSize: 16, color: 'black' }}>Data Rekam Medis</td>
                            </tr>
                        </tbody>
                    </table>
                    {rmall.map((data, index) =>
                        <table style={{ width: '100%', border: '1px solid black', marginBottom: 10 }}>
                            <thead style={{ width: '100%', border: '1px solid black', fontWeight: 'bold' }}>
                                <tr style={{ width: '100%', border: '1px solid black' }}>
                    <td colSpan={2} style={{ border: '1px solid black', padding: 10 }}>{moment(data.getdata[0].tanggal).format('LL')}</td>
                                </tr>
                                <tr style={{ width: '100%', border: '1px solid black' }}>
                                    <td style={{ border: '1px solid black', padding: 10 }}>ICD</td>
                                    <td style={{ border: '1px solid black', padding: 10 }}>Keterangan Lainnya</td>
                                </tr>
                            </thead>
                            <tbody style={{ width: '100%' }}>
                                {data.getdata.map((item, index) =>
                                    <tr style={{ width: '100%', border: '1px solid black' }}>
                                        <td style={{ borderRight: '1px solid black', padding: 10 }}>
                                            {item.icd} {item.nama_penyakit}
                                        </td>
                                        <td style={{ borderRight: '1px solid black', padding: 10 }}>
                                            {item.keterangan}
                                        </td>
                                    </tr>
                                )}

                            </tbody>
                        </table>
                    )}
                </table>
            </Modal>

        </Content>
    )
}

export default Pasien;



